import backend from 'network/BackendFetchAdapter';
import { Token } from 'types/security/token';
import { PasswordForm } from 'types/forms/PasswordForm';

export const userApi = {
  updatePassword: (passwordData: PasswordForm): Promise<Token> => backend.post('/api/users/password', passwordData),
};
